import React from 'react';
import styled from 'styled-components';
import { MdDeleteOutline } from 'react-icons/md';
import MainButton from '../buttons/MainButton';

const ItemCard = ({ title, onDelete, children, noMargin }) => {
    return (
        <Card $noMargin={noMargin}>
            <Header>
                <Title>{title}</Title>
                {onDelete && (
                    <MainButton
                        variant="danger"
                        size="small"
                        onClick={onDelete}
                        icon={<MdDeleteOutline size={18} />}
                        style={{ padding: '0.375rem 0.625rem', minWidth: 'auto' }}
                    />
                )}
            </Header>
            <Content>{children}</Content>
        </Card>
    );
};

export default ItemCard;

const Card = styled.div`
    background: #ffffff;
    border: 1px solid #eef0f2;
    border-radius: 12px;
    margin-bottom: ${({ $noMargin }) => ($noMargin ? '0' : '1rem')};
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
    overflow: hidden;

    &:hover {
        border-color: rgba(130, 22, 146, 0.25);
        box-shadow: 0 4px 12px rgba(130, 22, 146, 0.08);
        transform: translateY(-1px);
    }
`;

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem 1rem;
    border-bottom: 1px solid #f3f4f6;
    background: #fafafa;
`;

const Title = styled.h6`
    margin: 0;
    font-size: 0.875rem;
    font-weight: 700;
    color: #4b5563;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    display: flex;
    align-items: center;
    gap: 0.5rem;

    &::before {
        content: '';
        width: 3px;
        height: 14px;
        background: #821692;
        border-radius: 2px;
    }
`;

const Content = styled.div`
    padding: 1rem;
`;
